<template>
    <div class="version">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="7">
                    <a-row :gutter="10">
                        <a-col :span="17">
                            <a-input v-model="keyword" placeholder="请输入版本名称" />
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button type="primary" @click="add" v-if="$Func.check_rank('version_add')">发布新版本</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading" :pagination="page" bordered>
            <template slot="status" slot-scope="text">
                <a-tag :color="text == 1 ? 'green' : 'default'">{{text == 1 ? '已发布' : '草稿'}}</a-tag>
            </template>
            <template slot="force_update" slot-scope="text">
                <a-tag :color="text == 1 ? 'red' : 'default'">{{text == 1 ? '强制' : '可选'}}</a-tag>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a @click="()=>{update_data(record)}" v-if="$Func.check_rank('version_edit')">编辑</a>
                <a-divider type="vertical" />
                <a @click="()=>{delete_data(record)}" v-if="$Func.check_rank('version_del')">删除</a>
            </template>
        </a-table>

        <a-drawer
          title="发布新版本"
          :width="720"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="add_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="add_model=false"
           v-if="$Func.check_rank('version_add')"
        >
            <a-form-model :model="version_add" :rules="rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="version_name" prop="version_name" label="版本名称">
                            <a-input v-model="version_add.version_name" placeholder="如 1.0.1" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="version_code" prop="version_code" label="版本号(数字)">
                            <a-input-number v-model="version_add.version_code" style="width:100%;" placeholder="如 260526" :min="1" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="是否强制更新">
                            <a-radio-group v-model="version_add.force_update">
                                <a-radio :value="0">可选</a-radio>
                                <a-radio :value="1">强制</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="状态">
                            <a-radio-group v-model="version_add.status">
                                <a-radio :value="0">草稿</a-radio>
                                <a-radio :value="1">发布</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item ref="wgt_url" prop="wgt_url" label="WGT更新包地址">
                    <a-input v-model="version_add.wgt_url" placeholder="请输入WGT文件下载地址" />
                    <div style="margin-top:8px;">
                        <a-upload
                            :customRequest="upload_wgt"
                            :showUploadList="false"
                            accept=".wgt,.zip"
                        >
                            <a-button> <a-icon type="upload" /> 上传WGT包</a-button>
                        </a-upload>
                    </div>
                </a-form-model-item>
                <a-form-model-item ref="description" prop="description" label="更新说明">
                    <a-textarea v-model="version_add.description" :rows="6" placeholder="请输入更新说明，每条一行" />
                </a-form-model-item>
                <div :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }">
                    <a-button :style="{ marginRight: '8px' }" @click="add_model=false">
                        取消
                    </a-button>
                    <a-button type="primary" html-type="submit">
                        确定
                    </a-button>
                </div>
            </a-form-model>
        </a-drawer>

        <a-drawer
          title="编辑版本"
          :width="720"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="update_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="update_model=false"
           v-if="$Func.check_rank('version_edit')"
        >
            <a-form-model :model="version_update" :rules="rules" layout="vertical" ref="update_form" @submit="save_data">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="version_name" prop="version_name" label="版本名称">
                            <a-input v-model="version_update.version_name" placeholder="如 1.0.1" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="version_code" prop="version_code" label="版本号(数字)">
                            <a-input-number v-model="version_update.version_code" style="width:100%;" placeholder="如 260526" :min="1" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="是否强制更新">
                            <a-radio-group v-model="version_update.force_update">
                                <a-radio :value="0">可选</a-radio>
                                <a-radio :value="1">强制</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="状态">
                            <a-radio-group v-model="version_update.status">
                                <a-radio :value="0">草稿</a-radio>
                                <a-radio :value="1">发布</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item ref="wgt_url" prop="wgt_url" label="WGT更新包地址">
                    <a-input v-model="version_update.wgt_url" placeholder="请输入WGT文件下载地址" />
                    <div style="margin-top:8px;">
                        <a-upload
                            :customRequest="upload_wgt_update"
                            :showUploadList="false"
                            accept=".wgt,.zip"
                        >
                            <a-button> <a-icon type="upload" /> 上传WGT包</a-button>
                        </a-upload>
                    </div>
                </a-form-model-item>
                <a-form-model-item ref="description" prop="description" label="更新说明">
                    <a-textarea v-model="version_update.description" :rows="6" placeholder="请输入更新说明，每条一行" />
                </a-form-model-item>
                <div :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }">
                    <a-button :style="{ marginRight: '8px' }" @click="update_model=false">
                        取消
                    </a-button>
                    <a-button type="primary" html-type="submit">
                        确定
                    </a-button>
                </div>
            </a-form-model>
        </a-drawer>
    </div>
</template>

<script>
    import Func from '../../common/func'
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 60,
        },
        {
            title: '版本名称',
            dataIndex: 'version_name',
            key: 'version_name',
        },
        {
            title: '版本号',
            dataIndex: 'version_code',
            key: 'version_code',
            width: 100,
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 80,
            scopedSlots: { customRender: 'status' },
        },
        {
            title: '强制更新',
            dataIndex: 'force_update',
            key: 'force_update',
            width: 80,
            scopedSlots: { customRender: 'force_update' },
        },
        {
            title: '更新说明',
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
        },
        {
            title: '创建时间',
            dataIndex: 'created',
            key: 'created',
            width: 160,
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: 120,
            key:'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    export default {
        name: 'Version',
        data(){
            return {
                columns,
                form: this.$form.createForm(this),
                keyword:'',
                tableData:[],
                loading:false,
                add_model:false,
                update_model:false,
                version_add:{
                    version_name:'',
                    version_code:'',
                    wgt_url:'',
                    description:'',
                    force_update:0,
                    status:1,
                },
                version_update:{
                    id:'',
                    version_name:'',
                    version_code:'',
                    wgt_url:'',
                    description:'',
                    force_update:0,
                    status:1,
                },
                rules: {
                    version_name:[{ required: true, message: '请输入版本名称', trigger: 'blur' }],
                    version_code:[{ required: true, message: '请输入版本号', trigger: 'blur' }],
                    wgt_url:[{ required: true, message: '请输入WGT文件地址', trigger: 'blur' }],
                },
                page:{
                    current:1,
                    total:0,
                    pageSize:10
                }
            }
        },
        mounted() {
            this.get_data();
        },
        methods: {
            change_filter(pagination){
                this.get_data(pagination.current);
            },
            get_data(page,tip) {
                var keyword = this.keyword;
                if (!page) {
                    page = this.page.current||1;
                }

                if(!tip){
                    this.loading = true
                }

                Func.url_get({
                    action:'version',
                    keyword: keyword,
                    page: page
                },(res) => {
                    this.tableData = res.info.list;
                    var pagination={
                        pageSize:10,
                        total:res.info.foot.total,
                        current:parseInt(res.info.foot.current)
                    }
                    this.page=pagination;
                    this.loading = false
                });
            },
            add(){
                this.version_add={
                    version_name:'',
                    version_code:'',
                    wgt_url:'',
                    description:'',
                    force_update:0,
                    status:1,
                };
                this.add_model=true;
            },
            add_data(e){
                e.preventDefault();
                this.$refs.add_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'version.add_data',
                            ...this.version_add
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.add_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
            save_data(e){
                e.preventDefault();
                this.$refs.update_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'version.save_data',
                            ...this.version_update
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.update_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
            update_data(res){
                Func.url_get({
                    action:'version.find_data',
                    id:res.id
                },(res) => {
                    if(res.error===0){
                        this.version_update=res.info;
                        this.update_model=true;
                    }else{
                        this.$message.error(res.info);
                    }
                });
            },
            delete_data(item){
                if(confirm('确定要删除该版本吗')==true){
                    Func.url_get({
                        action:'version.del_data',
                        id:item.id
                    },(res) => {
                        if(res.error===0){
                            this.$message.success(res.info);
                            this.get_data(1,true);
                        }else{
                            this.$message.error(res.info);
                        }
                    });
                }
            },
            upload_wgt(file){
                //上传WGT文件
                var formData = new FormData();
                formData.append('action', 'api.ed_upload');
                formData.append('file', file.file);

                Func.url_form({
                    action:'api.ed_upload',
                    file:file.file
                },(res) => {
                    if(res.error===0){
                        this.version_add.wgt_url = res.info;
                        this.$message.success('上传成功');
                    }else{
                        this.$message.error(res.info||'上传失败');
                    }
                });
            },
            upload_wgt_update(file){
                Func.url_form({
                    action:'api.ed_upload',
                    file:file.file
                },(res) => {
                    if(res.error===0){
                        this.version_update.wgt_url = res.info;
                        this.$message.success('上传成功');
                    }else{
                        this.$message.error(res.info||'上传失败');
                    }
                });
            },
        }
    }
</script>
<style lang="scss">
</style>
